/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as PublicRouteRouteImport } from './routes/_public/route'
import { Route as AuthedRouteRouteImport } from './routes/_authed/route'
import { Route as PublicIndexRouteImport } from './routes/_public/index'
import { Route as PublicUnlockRouteImport } from './routes/_public/unlock'
import { Route as PublicSecurityRouteImport } from './routes/_public/security'
import { Route as PublicRegisterRouteImport } from './routes/_public/register'
import { Route as PublicDesignRouteImport } from './routes/_public/design'
import { Route as AuthedAppRouteRouteImport } from './routes/_authed/app.route'
import { Route as AuthedAppIndexRouteImport } from './routes/_authed/app.index'
import { Route as AuthedAppSettingsSecurityRouteImport } from './routes/_authed/app.settings/security'
import { Route as AuthedAppSettingsPairingRouteImport } from './routes/_authed/app.settings/pairing'
import { Route as AuthedAppSettingsDiagnosticsRouteImport } from './routes/_authed/app.settings/diagnostics'
import { Route as AuthedAppItemNewRouteImport } from './routes/_authed/app.item.new'
import { Route as AuthedAppItemItemIdRouteImport } from './routes/_authed/app.item.$itemId'
import { Route as AuthedAppItemNewIndexRouteImport } from './routes/_authed/app.item.new.index'
import { Route as AuthedAppItemNewTypeRouteImport } from './routes/_authed/app.item.new.$type'

const PublicRouteRoute = PublicRouteRouteImport.update({
  id: '/_public',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedRouteRoute = AuthedRouteRouteImport.update({
  id: '/_authed',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicIndexRoute = PublicIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PublicRouteRoute,
} as any)
const PublicUnlockRoute = PublicUnlockRouteImport.update({
  id: '/unlock',
  path: '/unlock',
  getParentRoute: () => PublicRouteRoute,
} as any)
const PublicSecurityRoute = PublicSecurityRouteImport.update({
  id: '/security',
  path: '/security',
  getParentRoute: () => PublicRouteRoute,
} as any)
const PublicRegisterRoute = PublicRegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => PublicRouteRoute,
} as any)
const PublicDesignRoute = PublicDesignRouteImport.update({
  id: '/design',
  path: '/design',
  getParentRoute: () => PublicRouteRoute,
} as any)
const AuthedAppRouteRoute = AuthedAppRouteRouteImport.update({
  id: '/app',
  path: '/app',
  getParentRoute: () => AuthedRouteRoute,
} as any)
const AuthedAppIndexRoute = AuthedAppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedAppRouteRoute,
} as any)
const AuthedAppSettingsSecurityRoute =
  AuthedAppSettingsSecurityRouteImport.update({
    id: '/settings/security',
    path: '/settings/security',
    getParentRoute: () => AuthedAppRouteRoute,
  } as any)
const AuthedAppSettingsPairingRoute =
  AuthedAppSettingsPairingRouteImport.update({
    id: '/settings/pairing',
    path: '/settings/pairing',
    getParentRoute: () => AuthedAppRouteRoute,
  } as any)
const AuthedAppSettingsDiagnosticsRoute =
  AuthedAppSettingsDiagnosticsRouteImport.update({
    id: '/settings/diagnostics',
    path: '/settings/diagnostics',
    getParentRoute: () => AuthedAppRouteRoute,
  } as any)
const AuthedAppItemNewRoute = AuthedAppItemNewRouteImport.update({
  id: '/item/new',
  path: '/item/new',
  getParentRoute: () => AuthedAppRouteRoute,
} as any)
const AuthedAppItemItemIdRoute = AuthedAppItemItemIdRouteImport.update({
  id: '/item/$itemId',
  path: '/item/$itemId',
  getParentRoute: () => AuthedAppRouteRoute,
} as any)
const AuthedAppItemNewIndexRoute = AuthedAppItemNewIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedAppItemNewRoute,
} as any)
const AuthedAppItemNewTypeRoute = AuthedAppItemNewTypeRouteImport.update({
  id: '/$type',
  path: '/$type',
  getParentRoute: () => AuthedAppItemNewRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof PublicIndexRoute
  '/app': typeof AuthedAppRouteRouteWithChildren
  '/design': typeof PublicDesignRoute
  '/register': typeof PublicRegisterRoute
  '/security': typeof PublicSecurityRoute
  '/unlock': typeof PublicUnlockRoute
  '/app/': typeof AuthedAppIndexRoute
  '/app/item/$itemId': typeof AuthedAppItemItemIdRoute
  '/app/item/new': typeof AuthedAppItemNewRouteWithChildren
  '/app/settings/diagnostics': typeof AuthedAppSettingsDiagnosticsRoute
  '/app/settings/pairing': typeof AuthedAppSettingsPairingRoute
  '/app/settings/security': typeof AuthedAppSettingsSecurityRoute
  '/app/item/new/$type': typeof AuthedAppItemNewTypeRoute
  '/app/item/new/': typeof AuthedAppItemNewIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof PublicIndexRoute
  '/design': typeof PublicDesignRoute
  '/register': typeof PublicRegisterRoute
  '/security': typeof PublicSecurityRoute
  '/unlock': typeof PublicUnlockRoute
  '/app': typeof AuthedAppIndexRoute
  '/app/item/$itemId': typeof AuthedAppItemItemIdRoute
  '/app/settings/diagnostics': typeof AuthedAppSettingsDiagnosticsRoute
  '/app/settings/pairing': typeof AuthedAppSettingsPairingRoute
  '/app/settings/security': typeof AuthedAppSettingsSecurityRoute
  '/app/item/new/$type': typeof AuthedAppItemNewTypeRoute
  '/app/item/new': typeof AuthedAppItemNewIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authed': typeof AuthedRouteRouteWithChildren
  '/_public': typeof PublicRouteRouteWithChildren
  '/_authed/app': typeof AuthedAppRouteRouteWithChildren
  '/_public/design': typeof PublicDesignRoute
  '/_public/register': typeof PublicRegisterRoute
  '/_public/security': typeof PublicSecurityRoute
  '/_public/unlock': typeof PublicUnlockRoute
  '/_public/': typeof PublicIndexRoute
  '/_authed/app/': typeof AuthedAppIndexRoute
  '/_authed/app/item/$itemId': typeof AuthedAppItemItemIdRoute
  '/_authed/app/item/new': typeof AuthedAppItemNewRouteWithChildren
  '/_authed/app/settings/diagnostics': typeof AuthedAppSettingsDiagnosticsRoute
  '/_authed/app/settings/pairing': typeof AuthedAppSettingsPairingRoute
  '/_authed/app/settings/security': typeof AuthedAppSettingsSecurityRoute
  '/_authed/app/item/new/$type': typeof AuthedAppItemNewTypeRoute
  '/_authed/app/item/new/': typeof AuthedAppItemNewIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/app'
    | '/design'
    | '/register'
    | '/security'
    | '/unlock'
    | '/app/'
    | '/app/item/$itemId'
    | '/app/item/new'
    | '/app/settings/diagnostics'
    | '/app/settings/pairing'
    | '/app/settings/security'
    | '/app/item/new/$type'
    | '/app/item/new/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/design'
    | '/register'
    | '/security'
    | '/unlock'
    | '/app'
    | '/app/item/$itemId'
    | '/app/settings/diagnostics'
    | '/app/settings/pairing'
    | '/app/settings/security'
    | '/app/item/new/$type'
    | '/app/item/new'
  id:
    | '__root__'
    | '/_authed'
    | '/_public'
    | '/_authed/app'
    | '/_public/design'
    | '/_public/register'
    | '/_public/security'
    | '/_public/unlock'
    | '/_public/'
    | '/_authed/app/'
    | '/_authed/app/item/$itemId'
    | '/_authed/app/item/new'
    | '/_authed/app/settings/diagnostics'
    | '/_authed/app/settings/pairing'
    | '/_authed/app/settings/security'
    | '/_authed/app/item/new/$type'
    | '/_authed/app/item/new/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthedRouteRoute: typeof AuthedRouteRouteWithChildren
  PublicRouteRoute: typeof PublicRouteRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_public': {
      id: '/_public'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof PublicRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed': {
      id: '/_authed'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public/': {
      id: '/_public/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof PublicIndexRouteImport
      parentRoute: typeof PublicRouteRoute
    }
    '/_public/unlock': {
      id: '/_public/unlock'
      path: '/unlock'
      fullPath: '/unlock'
      preLoaderRoute: typeof PublicUnlockRouteImport
      parentRoute: typeof PublicRouteRoute
    }
    '/_public/security': {
      id: '/_public/security'
      path: '/security'
      fullPath: '/security'
      preLoaderRoute: typeof PublicSecurityRouteImport
      parentRoute: typeof PublicRouteRoute
    }
    '/_public/register': {
      id: '/_public/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof PublicRegisterRouteImport
      parentRoute: typeof PublicRouteRoute
    }
    '/_public/design': {
      id: '/_public/design'
      path: '/design'
      fullPath: '/design'
      preLoaderRoute: typeof PublicDesignRouteImport
      parentRoute: typeof PublicRouteRoute
    }
    '/_authed/app': {
      id: '/_authed/app'
      path: '/app'
      fullPath: '/app'
      preLoaderRoute: typeof AuthedAppRouteRouteImport
      parentRoute: typeof AuthedRouteRoute
    }
    '/_authed/app/': {
      id: '/_authed/app/'
      path: '/'
      fullPath: '/app/'
      preLoaderRoute: typeof AuthedAppIndexRouteImport
      parentRoute: typeof AuthedAppRouteRoute
    }
    '/_authed/app/settings/security': {
      id: '/_authed/app/settings/security'
      path: '/settings/security'
      fullPath: '/app/settings/security'
      preLoaderRoute: typeof AuthedAppSettingsSecurityRouteImport
      parentRoute: typeof AuthedAppRouteRoute
    }
    '/_authed/app/settings/pairing': {
      id: '/_authed/app/settings/pairing'
      path: '/settings/pairing'
      fullPath: '/app/settings/pairing'
      preLoaderRoute: typeof AuthedAppSettingsPairingRouteImport
      parentRoute: typeof AuthedAppRouteRoute
    }
    '/_authed/app/settings/diagnostics': {
      id: '/_authed/app/settings/diagnostics'
      path: '/settings/diagnostics'
      fullPath: '/app/settings/diagnostics'
      preLoaderRoute: typeof AuthedAppSettingsDiagnosticsRouteImport
      parentRoute: typeof AuthedAppRouteRoute
    }
    '/_authed/app/item/new': {
      id: '/_authed/app/item/new'
      path: '/item/new'
      fullPath: '/app/item/new'
      preLoaderRoute: typeof AuthedAppItemNewRouteImport
      parentRoute: typeof AuthedAppRouteRoute
    }
    '/_authed/app/item/$itemId': {
      id: '/_authed/app/item/$itemId'
      path: '/item/$itemId'
      fullPath: '/app/item/$itemId'
      preLoaderRoute: typeof AuthedAppItemItemIdRouteImport
      parentRoute: typeof AuthedAppRouteRoute
    }
    '/_authed/app/item/new/': {
      id: '/_authed/app/item/new/'
      path: '/'
      fullPath: '/app/item/new/'
      preLoaderRoute: typeof AuthedAppItemNewIndexRouteImport
      parentRoute: typeof AuthedAppItemNewRoute
    }
    '/_authed/app/item/new/$type': {
      id: '/_authed/app/item/new/$type'
      path: '/$type'
      fullPath: '/app/item/new/$type'
      preLoaderRoute: typeof AuthedAppItemNewTypeRouteImport
      parentRoute: typeof AuthedAppItemNewRoute
    }
  }
}

interface AuthedAppItemNewRouteChildren {
  AuthedAppItemNewTypeRoute: typeof AuthedAppItemNewTypeRoute
  AuthedAppItemNewIndexRoute: typeof AuthedAppItemNewIndexRoute
}

const AuthedAppItemNewRouteChildren: AuthedAppItemNewRouteChildren = {
  AuthedAppItemNewTypeRoute: AuthedAppItemNewTypeRoute,
  AuthedAppItemNewIndexRoute: AuthedAppItemNewIndexRoute,
}

const AuthedAppItemNewRouteWithChildren =
  AuthedAppItemNewRoute._addFileChildren(AuthedAppItemNewRouteChildren)

interface AuthedAppRouteRouteChildren {
  AuthedAppIndexRoute: typeof AuthedAppIndexRoute
  AuthedAppItemItemIdRoute: typeof AuthedAppItemItemIdRoute
  AuthedAppItemNewRoute: typeof AuthedAppItemNewRouteWithChildren
  AuthedAppSettingsDiagnosticsRoute: typeof AuthedAppSettingsDiagnosticsRoute
  AuthedAppSettingsPairingRoute: typeof AuthedAppSettingsPairingRoute
  AuthedAppSettingsSecurityRoute: typeof AuthedAppSettingsSecurityRoute
}

const AuthedAppRouteRouteChildren: AuthedAppRouteRouteChildren = {
  AuthedAppIndexRoute: AuthedAppIndexRoute,
  AuthedAppItemItemIdRoute: AuthedAppItemItemIdRoute,
  AuthedAppItemNewRoute: AuthedAppItemNewRouteWithChildren,
  AuthedAppSettingsDiagnosticsRoute: AuthedAppSettingsDiagnosticsRoute,
  AuthedAppSettingsPairingRoute: AuthedAppSettingsPairingRoute,
  AuthedAppSettingsSecurityRoute: AuthedAppSettingsSecurityRoute,
}

const AuthedAppRouteRouteWithChildren = AuthedAppRouteRoute._addFileChildren(
  AuthedAppRouteRouteChildren,
)

interface AuthedRouteRouteChildren {
  AuthedAppRouteRoute: typeof AuthedAppRouteRouteWithChildren
}

const AuthedRouteRouteChildren: AuthedRouteRouteChildren = {
  AuthedAppRouteRoute: AuthedAppRouteRouteWithChildren,
}

const AuthedRouteRouteWithChildren = AuthedRouteRoute._addFileChildren(
  AuthedRouteRouteChildren,
)

interface PublicRouteRouteChildren {
  PublicDesignRoute: typeof PublicDesignRoute
  PublicRegisterRoute: typeof PublicRegisterRoute
  PublicSecurityRoute: typeof PublicSecurityRoute
  PublicUnlockRoute: typeof PublicUnlockRoute
  PublicIndexRoute: typeof PublicIndexRoute
}

const PublicRouteRouteChildren: PublicRouteRouteChildren = {
  PublicDesignRoute: PublicDesignRoute,
  PublicRegisterRoute: PublicRegisterRoute,
  PublicSecurityRoute: PublicSecurityRoute,
  PublicUnlockRoute: PublicUnlockRoute,
  PublicIndexRoute: PublicIndexRoute,
}

const PublicRouteRouteWithChildren = PublicRouteRoute._addFileChildren(
  PublicRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AuthedRouteRoute: AuthedRouteRouteWithChildren,
  PublicRouteRoute: PublicRouteRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
